import { APP_EXTRACT, APP_FEASIBILITY } from "./Constant";
import { AppConfigType } from "./Types";

export const AppConfig: AppConfigType = {
  MenuList: [
    {
      menuName: "Details",
      availableIn: [
        APP_EXTRACT,
        APP_FEASIBILITY
      ]
    },
    {
      menuName: "Output config",
      availableIn: [
        APP_EXTRACT
      ]
    },
    {
      menuName: "OptOut",
      availableIn: [
        APP_FEASIBILITY
      ]
    },
    {
      menuName: "Schedule",
      availableIn: [
        APP_EXTRACT
      ]
    },
    {
      menuName: "Versioning",
      availableIn: [
        APP_EXTRACT,
        APP_FEASIBILITY
      ]
    },
    {
      menuName: "Execute",
      availableIn: [
        APP_EXTRACT,
        APP_FEASIBILITY
      ]
    },
    {
      menuName: "Results",
      availableIn: [
        APP_FEASIBILITY
      ]
    }
  ],
  TableColumns: [
    {
      columnName: "patientId",
      availableIn: [
        APP_EXTRACT
      ]
    },
    {
      columnName: "organisation",
      availableIn: [
        APP_EXTRACT,
        APP_FEASIBILITY
      ]
    },
    {
      columnName: "name",
      availableIn: [
        APP_EXTRACT
      ]
    },
    {
      columnName: "age",
      availableIn: [
        APP_EXTRACT,
        APP_FEASIBILITY
      ]
    },
    {
      columnName: "sex",
      availableIn: [
        APP_EXTRACT,
        APP_FEASIBILITY
      ]
    },
    {
      columnName: "usualGP",
      availableIn: [
        APP_EXTRACT
      ]
    },
    {
      columnName: "NHSNumber",
      availableIn: [
        APP_EXTRACT
      ]
    }
  ],
  executeInDualMode: [
    APP_FEASIBILITY
  ],
  anonymize: [
    APP_FEASIBILITY,
  ]
};
